import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import MarketingHeader from "../components/argus/MarketingHeader";
import Footer from "../components/argus/Footer";
import { Button } from "../components/ui/button";
import { PRODUCTS } from "../lib/marketingContent";

export default function Product() {
  const { slug } = useParams();
  const p = PRODUCTS[slug];
  if (!p) return <Navigate to="/" replace />;

  const related = Object.values(PRODUCTS).filter((x) => x.slug !== slug).slice(0, 3);

  return (
    <div className="bg-paper text-ink min-h-screen flex flex-col">
      <MarketingHeader />
      <section className="mx-auto max-w-6xl w-full px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <p className="text-xs uppercase tracking-wider text-gold mb-3 font-semibold" data-testid="product-short">{p.short}</p>
        <h1 className="font-display text-5xl sm:text-6xl tracking-tight max-w-3xl" data-testid="product-title">{p.tagline}</h1>
        <p className="mt-6 text-lg text-ink/70 max-w-2xl" data-testid="product-summary">{p.summary}</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/signup">
            <Button className="bg-gold text-paper hover:bg-gold2 h-12 px-6 font-semibold" data-testid="product-cta">
              {p.cta} <ArrowRight size={16} className="ml-2" />
            </Button>
          </Link>
          <Link to="/pricing">
            <Button variant="outline" className="h-12 px-6 border-line bg-transparent hover:bg-raised text-ink" data-testid="product-pricing-cta">
              See Pricing
            </Button>
          </Link>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-8">
          <div>
            <h2 className="font-display text-3xl mb-6">What you get.</h2>
            <ul className="space-y-3">
              {p.bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-3 text-ink/80" data-testid={`product-bullet-${i}`}>
                  <CheckCircle2 size={18} className="text-safe shrink-0 mt-0.5" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-xl border border-line bg-panel p-6">
            <h3 className="font-display text-xl mb-3">How it fits.</h3>
            <p className="text-sm text-ink/70 mb-4">ArgusSecure is one platform — every scanner shares one inbox, one risk score, one fix-it panel.</p>
            <ul className="space-y-2 text-sm">
              {related.map((r) => (
                <li key={r.slug}>
                  <Link to={`/products/${r.slug}`} className="text-ink/80 hover:text-gold" data-testid={`product-related-${r.slug}`}>
                    {r.name} <span className="text-ink/40 text-xs">— {r.short}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
